import AreaRolesTable from './area-roles-table-view'

export default AreaRolesTable
